import { render, staticRenderFns } from "./VictimInformation.vue?vue&type=template&id=62d2cdf8&scoped=true"
import script from "./VictimInformation.vue?vue&type=script&lang=js"
export * from "./VictimInformation.vue?vue&type=script&lang=js"
import style0 from "./VictimInformation.vue?vue&type=style&index=0&id=62d2cdf8&prod&scoped=true&lang=css"
import style1 from "./VictimInformation.vue?vue&type=style&index=1&id=62d2cdf8&prod&lang=css"
import style2 from "./VictimInformation.vue?vue&type=style&index=2&id=62d2cdf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2cdf8",
  null
  
)

export default component.exports